/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { UserModelSearchResultModel } from '../../models/user-model-search-result-model';

export interface UserSearchUserPost$Json$Params {
      body?: SearchRequestModel
}

export function userSearchUserPost$Json(http: HttpClient, rootUrl: string, params?: UserSearchUserPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, userSearchUserPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<UserModelSearchResultModel>;
    })
  );
}

userSearchUserPost$Json.PATH = '/User/SearchUser';
